import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Hexagon, Phone, Mail, MessageCircle } from "lucide-react";
import api from "@/lib/api";

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/public/settings").then((r) => setS(r.data)).catch(() => {}); }, []);

  return (
    <footer className="bg-[#070A12] border-t border-white/10 pt-16 pb-10 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-cyan-500">
              <Hexagon className="w-5 h-5 text-white" strokeWidth={2.4} />
            </span>
            <div className="font-display font-bold text-white text-lg">Nova Web Solutions</div>
          </div>
          <p className="text-sm leading-relaxed">Premium Websites. Powerful First Impressions. We help local businesses win trust online.</p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link className="hover:text-white" to="/services">Services</Link></li>
            <li><Link className="hover:text-white" to="/portfolio">Portfolio</Link></li>
            <li><Link className="hover:text-white" to="/packages">Packages</Link></li>
            <li><Link className="hover:text-white" to="/process">Our Process</Link></li>
            <li><Link className="hover:text-white" to="/refer-earn">Refer & Earn</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link className="hover:text-white" to="/faq">FAQ</Link></li>
            <li><Link className="hover:text-white" to="/legal/privacy">Privacy Policy</Link></li>
            <li><Link className="hover:text-white" to="/legal/terms">Service Terms</Link></li>
            <li><Link className="hover:text-white" to="/legal/referral-terms">Referral Terms</Link></li>
            <li><Link className="hover:text-white" to="/admin/login">Admin Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Contact</h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-violet-400" />{s.phone || <span className="italic opacity-70">Phone to be configured</span>}</li>
            <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-emerald-400" />{s.whatsapp || <span className="italic opacity-70">WhatsApp to be configured</span>}</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-cyan-400" />{s.email || <span className="italic opacity-70">Email to be configured</span>}</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs">
        <span>© {new Date().getFullYear()} Nova Web Solutions. All rights reserved.</span>
        <span className="opacity-70">Policy content is pending business review before launch.</span>
      </div>
    </footer>
  );
}
